import React, { useEffect, useState} from 'react'
import { StyleSheet, View } from 'react-native'

import {
  Title,
  Button,
  Description,
  Space,
  Switch
} from '@sart/components'
import { Confirmation } from '@sart/icons'
import { colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'
import { testID } from '@sart/utilities'

export default function ProfilePaymentConfirmation(props) {
  const {
    cache
  } = useClient()

  const { navigation, route } = props
  
  const content = useContent()
  const order = route.params?.order

  useEffect(() => {
    loadScreen()
  },[])

  async function loadScreen() {
    client.clearCachedPayment()
    // basketHelper.clearCacheBasket()
    client.setCache({basket: []})
    client.loadPaymentPreference()
  }

  return (
    <View style={styles.container}>
      <Space height={24} />
      <Confirmation color={colors.white}/>
      <Space height={2 * 24} />

      <Title style={styles.title}>
      </Title>

      <Space height={24} />

      <Description style={styles.description}> </Description>

      <Space height={24} />
      <View style={styles.storedCard}>
        { order.status === 'successful' && 
          <Description style={styles.description} {...testID('paymentUpdateSuccess')}>{content.profile_payment.updateSuccess} {order.cardToken.tokenizedCard.last4Digits} {content.profile_payment.updateSuccessTwo}</Description>
        }
        { order.status === 'failed' &&
          <Description style={styles.description} {...testID('paymentUpdateFailed')}>{content.profile_payment.updateFailed}</Description>
        }
        <Space width={8} />
      </View>

      <Space height={48} />

      <Button
        style={styles.button}
        title={content.profile_payment.action}
        onPress={() => {
          navigation.popToTop()
          navigation.navigate('Account')
        }}
        titleStyle={{...typography.extrabold, fontSize: 18}}
        {...testID('paymentUpdateDone')}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.srDarkGreen,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.white
  },
  description: {
    textAlign: 'center',
    color: colors.white,
  },
  button: {
    alignSelf: 'stretch',
    backgroundColor:colors.srGreen
  },
  storedCard: {
    flexDirection: 'row'
  }
})
